import config from '../../config/app';
import { ONBOARDING_EXPERIMENT_THIRD_ARM_FEATURE_FLAG } from './selectors';

const TRIAL_OWNER_NO_GOALS_COMPLETE = {
  current_user: {
    name: 'Some User',
    email: 'someuser@pagerduty.com',
    time_zone: 'America/New_York',
    color: 'midnight-blue',
    avatar_url: 'https://secure.gravatar.com/avatar/21e204e34914c10fc225a1537337aad6.png?d=mm&r=PG',
    billed: true,
    role: 'owner',
    description: null,
    invitation_sent: false,
    job_title: null,
    contact_methods: [
      {
        id: 'PS9T3JD',
        type: 'email_contact_method_reference',
        summary: 'Default',
        self: 'https://api.pd-staging.com/users/PYE0EQ0/contact_methods/PS9T3JD',
        html_url: null
      }
    ],
    id: 'ABCDEFG',
    type: 'user',
    summary: 'Some User',
    can_see_entire_account: false,
    can_see_operational_reviews: true,
    can_create_configure_archive_operational_reviews: true,
    created_at: '2020-07-31T00:00:00Z',
    toggles: [{ name: config.FEATURE_TOGGLE }, { name: 'responders_nurture_bar' }]
  },
  current_account: {
    id: 'PFIGZHD',
    subdomain: 'pdt-circular',
    name: 'PagerDuty Internal Alerts',
    time_zone: 'America/Los_Angeles',
    state: 'trial',
    plan: 'paid',
    days_left_on_state: 5,
    users_count: 1,
    schedules_count: 0,
    escalation_policies_count: 0,
    first_ep_id: 'PD6LYSO',
  },
  account_features: {
    features: [
      'ack_as_assignment',
      'advanced_event_actions',
      'advanced_permissions',
      'advanced_reports',
      'advanced_reports_users_report',
      'advanced_urgencies',
      'alert_grouping_awareness',
      'allow_increased_targets_per_ep_level',
      'alpha_incident_indexing',
      'async_webhooks',
      'batch_resolve',
      'beta_alerts_list',
      'beta_api_user_tokens',
      'beta_custom_oet',
      'beta_ember_teams',
      'beta_event_transforms',
      'beta_new_event_rules_ui',
      'beta_pd_cef_ui',
      'beta_read_only_users',
      'beta_unreleased_cef_integrations_in_ui',
      'beta_websockets',
      'better_rvs',
      'bff_routing',
      'console_settings',
      'design_system',
      'dial_extensions',
      'email_parsers',
      'ember',
      'enable_artemis_notify_updates',
      'event_routing_priority',
      'example_app',
      'fast_schedules',
      'freshest_not_best',
      'get_incidents_from_artemis',
      'google_auth',
      'group_alerting_multi_ack',
      'group_alerting_polyrules',
      'grouped_nav',
      'hack_day_html_emails',
      'incident_resolve_confirm_dialog',
      'incidents_auto_refresh',
      'incidents_punting',
      'info_notification_rules',
      'kiosk_mode',
      'les_querier_cutover',
      'maintenance_mode',
      'manual_escalation',
      'manual_unacknowledge',
      'minute_zero_notifications',
      'new_alerts_page',
      'new_locking',
      'occ_custom_url_module',
      'occ_heatmap_module',
      'ochon_notify_advance',
      'on_call_api',
      'on_call_timeline',
      'oncall_handoffs',
      'operations_command_console',
      'operations_health',
      'platform_ecosystem',
      'postmortem_realtime',
      'postmortem_tags',
      'preview_business_services',
      'preview_coordinated_response',
      'preview_event_routing',
      'preview_event_routing_field_selector',
      'preview_incident_alert_split',
      'preview_incident_command_console',
      'preview_incident_priority',
      'preview_incident_slack_channels',
      'preview_intelligent_alert_grouping',
      'preview_scheduled_event_rules',
      'preview_stakeholders',
      'preview_threshold_triggering',
      'preview_use_alert_severity_for_incident_urgency',
      'push_ochon',
      'response_automation',
      'response_bridge_on_response_plays',
      'responseplays_mobile_android_v1',
      'responseplays_mobile_ios_v1',
      'schedule_snapshots',
      'send_test_notification',
      'server_side_sessions',
      'similar_incidents',
      'single_sign_on',
      'slacktion',
      'sms_ochon',
      'stakeholder_comms_long_sms_status_updates',
      'stakeholder_comms_sms_contains_update_content',
      'stakeholder_comms_use_compact_email_status_update',
      'status_dashboard',
      'status_dashboard_advanced',
      'teams',
      'teams_hierarchy',
      'time_based_alert_grouping',
      'universal_event_transform',
      'urgencies',
      'use_incident_priority',
      'use_team_service',
      'user_color',
      'user_report_live_updates',
      'ux_20',
      'webhooks',
      'wip_assign_incident_to_people',
      'wip_editable_incident_title',
      'wip_hours_on_call_column',
      'wip_icicle',
      'wip_preview_alert_grouping_tab',
      'enterprise',
    ]
  },
  permissions: {},
  roles: [
    'owner', 'admin', 'user', 'limited_user', 'observer', 'read_only_user', 'restricted_access', 'read_only_limited_user'
  ]
};

const TRIAL_OWNER_ADDED_USER = {
  ...TRIAL_OWNER_NO_GOALS_COMPLETE,
  current_account: {
    ...TRIAL_OWNER_NO_GOALS_COMPLETE.current_account,
    users_count: 2
  },
};

const TRIAL_OWNER_SHOW_ONBOARDING_EXPERIMENT = {
  ...TRIAL_OWNER_NO_GOALS_COMPLETE,
  account_features: {
    features: [ONBOARDING_EXPERIMENT_THIRD_ARM_FEATURE_FLAG],
  },
};

const TRIAL_OWNER_WITH_ONE_SCHEDULE = {
  ...TRIAL_OWNER_SHOW_ONBOARDING_EXPERIMENT,
  current_account: {
    ...TRIAL_OWNER_SHOW_ONBOARDING_EXPERIMENT.current_account,
    schedules_count: 1,
  },
};

const FREEMIUM_USER_NO_LIMITS_REACHED = {
  ...TRIAL_OWNER_NO_GOALS_COMPLETE,
  current_account: {
    ...TRIAL_OWNER_NO_GOALS_COMPLETE.current_account,
    state: 'freemium',
    plan: 'freemium',
  },
};

const FREEMIUM_USER_USERS_LIMIT_IN_CAUTION = {
  ...FREEMIUM_USER_NO_LIMITS_REACHED,
  current_account: {
    ...FREEMIUM_USER_NO_LIMITS_REACHED.current_account,
    users_count: 4,
  }
};

const FREEMIUM_USER_ALL_MAXED_OUT_LIMITS = {
  ...FREEMIUM_USER_NO_LIMITS_REACHED,
  current_account: {
    ...FREEMIUM_USER_NO_LIMITS_REACHED.current_account,
    users_count: 5,
    schedules_count: 1,
    escalation_policies_count: 1,
  }
};

const EXPIRED_USER = {
  ...TRIAL_OWNER_NO_GOALS_COMPLETE,
  current_account: {
    ...TRIAL_OWNER_NO_GOALS_COMPLETE.current_account,
    state: 'expired',
  },
};

const TRIAL_RESPONDER_NO_GOALS_COMPLETE = {
  ...TRIAL_OWNER_NO_GOALS_COMPLETE,
  current_user: {
    ...TRIAL_OWNER_NO_GOALS_COMPLETE.current_user,
    role: 'limited_user',
  }
};

const EXPIRED_ACCOUNT_RESPONDER = {
  ...TRIAL_RESPONDER_NO_GOALS_COMPLETE,
  current_account: {
    ...TRIAL_RESPONDER_NO_GOALS_COMPLETE.current_account,
    state: 'expired',
  },
};

const TRIAL_RESPONDER_ADDED_CONTACT_METHOD = {
  ...TRIAL_RESPONDER_NO_GOALS_COMPLETE,
  current_user: {
    ...TRIAL_RESPONDER_NO_GOALS_COMPLETE.current_user,
    contact_methods: [
      {
        id: 'PS9T3JD',
        type: 'email_contact_method_reference',
        summary: 'Default',
        self: 'https://api.pd-staging.com/users/PYE0EQ0/contact_methods/PS9T3JD',
        html_url: null
      },
      {
        id: 'PG260B4',
        type: 'phone_contact_method_reference',
        summary: 'Work',
        self: 'https://api.pd-staging.com/users/PYE0EQ0/contact_methods/PG260B4',
        html_url: null
      }
    ],
  }
};

const ACTIVE_OWNER_NO_GOALS_COMPLETE = {
  ...TRIAL_RESPONDER_NO_GOALS_COMPLETE,
  current_account: {
    ...TRIAL_RESPONDER_NO_GOALS_COMPLETE.current_account,
    state: 'active',
  },
};

const ACTIVE_RESPONDER_NO_GOALS_COMPLETE = {
  ...ACTIVE_OWNER_NO_GOALS_COMPLETE,
  current_user: {
    ...ACTIVE_OWNER_NO_GOALS_COMPLETE.current_user,
    role: 'limited_user',
  },
};

export default {
  freemium_user_no_limits_reached: FREEMIUM_USER_NO_LIMITS_REACHED,
  freemium_user_users_limit_in_caution: FREEMIUM_USER_USERS_LIMIT_IN_CAUTION,
  freemium_user_all_maxed_out_limits: FREEMIUM_USER_ALL_MAXED_OUT_LIMITS,
  trial_owner_no_goals_complete: TRIAL_OWNER_NO_GOALS_COMPLETE,
  trial_owner_added_user: TRIAL_OWNER_ADDED_USER,
  trial_owner_show_onboarding_experiment: TRIAL_OWNER_SHOW_ONBOARDING_EXPERIMENT,
  trial_owner_one_schedule_variant: TRIAL_OWNER_WITH_ONE_SCHEDULE,
  trial_responder_no_goals_complete: TRIAL_RESPONDER_NO_GOALS_COMPLETE,
  trial_responder_added_contact_method: TRIAL_RESPONDER_ADDED_CONTACT_METHOD,
  expired_user: EXPIRED_USER,
  active_owner_no_goals_complete: ACTIVE_OWNER_NO_GOALS_COMPLETE,
  active_responder_no_goals_complete: ACTIVE_RESPONDER_NO_GOALS_COMPLETE,
  expired_account_responder: EXPIRED_ACCOUNT_RESPONDER,
};
